import React from 'react';
import { useTranslation } from "react-i18next";
import { BsInfoCircle } from "react-icons/bs";
import ReactTooltip from 'react-tooltip';

const INDICATORS_CONFIG = [
    { key: "deep_indicator" },
    { key: "protection_indicator" },
    { key: "applicability_indicator", isInverted: true }, 
    { key: "relevance_indicator" },
    { key: "mitigation_indicator" },
    { key: "adaptation_indicator" },
    { key: "performance_indicator" },
];

const ViewTextGenericIndicators = ({ 
    values, 
    occupation = 6, 
    moduleKey = "technology",
    tooltipPlace = "top" 
}) => {
    const { t } = useTranslation();

    const getBarColor = (val, isInverted = false) => {
        if (isInverted) {
            if (val < 40) return '#a2cb7e'; // Verde
            if (val < 70) return '#ffa500'; // Naranja
            return '#ff4d4d';               // Rojo
        } else {
            if (val < 40) return '#ff4d4d'; 
            if (val < 70) return '#ffa500'; 
            return '#a2cb7e';               
        }
    };

    const IndicatorRow = ({ indicatorKey, value, isInverted }) => {
        const tooltipId = `${indicatorKey}_tip_p`;
        const displayValue = value || 0;
        const barColor = getBarColor(displayValue, isInverted);

        return (
            <div className="indicator-row">
                <div className="indicator-label">
                    <div className="label-wrapper">
                        <BsInfoCircle className="info-icon" data-tip data-for={tooltipId} />
                        <span className="label-text">
                            {t(`${moduleKey}.indicator.${indicatorKey}`)}
                            <span className="label-arrow">→</span>
                        </span>
                    </div>
                </div>

                <div className="bar-container">
                    <div 
                        className="bar-fill" 
                        style={{ width: `${displayValue}%`, '--bar-color': barColor }}
                    >
                        {displayValue > 12 && <span className="bar-percentage">{displayValue}%</span>}
                    </div>
                    {displayValue <= 12 && (
                        <span className="bar-percentage outer" style={{ left: `${displayValue + 1}%` }}>
                            {displayValue}%
                        </span>
                    )}
                </div>

                <ReactTooltip id={tooltipId} place={tooltipPlace} effect="solid" backgroundColor="#2c3e50" textColor="white">
                    <div style={{ maxWidth: '200px', whiteSpace: 'normal' }}>
                        {t(`${moduleKey}.synthetic.${indicatorKey}`)}
                    </div>
                </ReactTooltip>
            </div>
        );
    };

    return (
        <div className={`col-md-${occupation} viewContentGroup`}>
            <div className='indicatorsGraphicView'>
                <div className="tit-view-view tit-content-view-view tit-view-bottom">
                    {t(`general.indicators_title`)}
                </div>
                
                <div className="indicators-container">
                    {INDICATORS_CONFIG.map((indicator) => (
                        <IndicatorRow 
                            key={indicator.key}
                            indicatorKey={indicator.key}
                            value={values[indicator.key]}
                            isInverted={indicator.isInverted}
                        />
                    ))}
                </div>

                {/* --- SECCIÓN DE LEYENDA --- */}
                <div className="indicators-legend" style={{ 
                    marginTop: '20px', 
                    display: 'flex', 
                    gap: '20px', 
                    justifyContent: 'center',
                    fontSize: '0.85rem',
                    color: '#666'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#a2cb7e' }}></div>
                        <span>Desempeño Óptimo / Baja Exigencia</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#ffa500' }}></div>
                        <span>Desempeño Medio</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#ff4d4d' }}></div>
                        <span>Desempeño Crítico / Alta Exigencia</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewTextGenericIndicators;
